import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { Alertas, AlertasData } from './alertas';

@Injectable({
  providedIn: 'root',
})
export class AlertasService {
  private dialog = inject(MatDialog);

  /**
   * Abre la modal de Alertas pasando los datos opcionales de configuración.
   */
  open(data?: AlertasData): MatDialogRef<Alertas, boolean> {
    return this.dialog.open<Alertas, AlertasData, boolean>(Alertas, {
      data,
      panelClass: 'alertas-dialog-panel',
      autoFocus: false,
      restoreFocus: false,
      disableClose: false,
      maxWidth: '90vw',
      width: '440px',
    });
  }

  /**
   * Muestra una modal de confirmación y retorna Promise<boolean> (true si confirma, false si se rechaza/cancela).
   * Acepta un objeto AlertasData o una cadena de texto directa como mensaje.
   */
  async confirm(options?: AlertasData | string): Promise<boolean> {
    const data: AlertasData = typeof options === 'string'
      ? { message: options }
      : (options ?? {});

    const dialogRef = this.open(data);
    const result = await firstValueFrom(dialogRef.afterClosed());
    return !!result;
  }

  /**
   * Muestra una alerta informativa (sin botón de cancelar) y retorna Promise<void> al cerrarse.
   */
  async alert(options?: AlertasData | string): Promise<void> {
    const data: AlertasData = typeof options === 'string'
      ? { message: options, showCancel: false }
      : { ...options, showCancel: false };

    const dialogRef = this.open(data);
    await firstValueFrom(dialogRef.afterClosed());
  }
}
